export const dateEditorOptions = {
    useMaskBehavior: true,
};

export const notesEditorOptions = { height: 100 };

export const dateFormat = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
};

export const formatNumberOptions = {
    type: "fixedPoint",
    precision: 3
};

export const formatNumberOptionsMax2 = {
    type: "fixedPoint",
    precision: 2
};

export const formatNumberOptionsMax0 = {
    type: "fixedPoint",
    precision: 0
};

export const amountEditorOptions = {
    format: formatNumberOptions,
    showClearButton: true
};

export const amountEditorOptionsMax2 = {
    format: formatNumberOptionsMax2,
    showClearButton: true
};

export const amountEditorOptionsMax0 = {
    format: formatNumberOptionsMax0,
    showClearButton: true
};

export const lookupColumnEditorOptions = { showClearButton: true };

export const getAmountEditorOptions = (precision) => ({
    format: {
        type: "fixedPoint",
        precision
    },
    showClearButton: true
});